import swIcon from '../images/service/1.svg'
import swImgS1 from '../images/service-single/web/img-1.jpg'
import swImgS2 from '../images/service-single/web/img-2.jpg'
import swImgS3 from '../images/service-single/web/img-3.jpg'

import saIcon from '../images/service/2.svg'
import saImgS1 from '../images/service-single/app/img-1.jpg'
import saImgS2 from '../images/service-single/app/img-2.jpg'
import saImgS3 from '../images/service-single/app/img-3.jpg'

import sWaIcon from '../images/service/3.svg'
import sWaImgS1 from '../images/service-single/webapp/img-1.jpg'
import sWaImgS2 from '../images/service-single/webapp/img-2.jpg'
import sWaImgS3 from '../images/service-single/webapp/img-3.jpg'

import sbIcon from '../images/service/4.svg'
import sbImgS1 from '../images/service-single/brand/img-1.jpg'
import sbImgS2 from '../images/service-single/brand/img-2.jpg'
import sbImgS3 from '../images/service-single/brand/img-3.jpg'

import sGIcon from '../images/service/5.svg'
import sGImgS1 from '../images/service-single/graphic/img-1.jpg'
import sGImgS2 from '../images/service-single/graphic/img-2.jpg'
import sGImgS3 from '../images/service-single/graphic/img-3.jpg'

import sUxIcon from '../images/service/6.svg'
import sUxImgS1 from '../images/service-single/ux/img-1.jpg'
import sUxImgS2 from '../images/service-single/ux/img-2.jpg'
import sUxImgS3 from '../images/service-single/ux/img-3.jpg'



const Services = [
    {
        Id: '1',
        sIcon:swIcon,
        sImgS:swImgS1,
        sTitle: 'Web Development',
        description:'Custom websites with React.js, Node.js, Bootstrap, and WordPress, built with clean code and SEO in mind.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:swImgS2,
        ssImg2:swImgS3,
    },
    {
        Id: '2',
        sIcon:saIcon,
        sImgS:saImgS1,
        sTitle: 'Graphic Designing',
        description:'Creative logos, banners, and visuals that make your brand stand out.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:saImgS2,
        ssImg2:saImgS3,
    },
    {
        Id: '3',
        sIcon:sWaIcon,
        sImgS:sWaImgS1,
        sTitle: 'SEO & Content Writing',
        description:'SEO-friendly content to improve rankings and drive traffic.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sWaImgS2,
        ssImg2:sWaImgS3,
    },
    {
        Id: '4',
        sIcon:sbIcon,
        sImgS:sbImgS1,
        sTitle: 'Brand Design',
        description:'I have complete 180+ Brand Design for my clients.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sbImgS2,
        ssImg2:sbImgS3,
    },
    {
        Id: '5',
        sIcon:sGIcon,
        sImgS:sGImgS1,
        sTitle: 'Graphic Design',
        description:'I have complete 200+ Graphic Design for my clients.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sGImgS2,
        ssImg2:sGImgS3,
    },
    {
        Id: '6',
        sIcon:sUxIcon,
        sImgS:sUxImgS1,
        sTitle: 'UX/UI Design',
        description:'I have complete 200+ UX/UI Design for my clients.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sUxImgS2,
        ssImg2:sUxImgS3,
    },
]    

export default Services;